import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import type { EnvironmentType } from '@src/environments/environment.types';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  get apiBaseUrl(): string {
    return environment.config.API_BASE_URL;
  }

  get eclPlatformUrl(): string {
    return environment.config.ECL_PLATFORM_URL;
  }

  get environmentType(): EnvironmentType {
    return environment.type;
  }

  get isProduction(): boolean {
    return environment.production;
  }
}
